// src/pages/Tickets/TicketAssignmentHistory.jsx
// -----------------------------------------------------------------------------
// "Assignments" tab on Ticket Detail (Requirement #19: track assignment history).
// Lists every assignment of the ticket - current and past - with who assigned
// it and when it started / ended, newest first.
// -----------------------------------------------------------------------------
import PropTypes from 'prop-types';

const formatDate = (value) => (value ? new Date(value).toLocaleString() : '—');

export default function TicketAssignmentHistory({ assignments, userName }) {
  if (!assignments || assignments.length === 0) {
    return <p className="text-muted">This ticket has never been assigned.</p>;
  }

  const rows = [...assignments].sort(
    (a, b) => new Date(b.assignedDttm || 0) - new Date(a.assignedDttm || 0)
  );

  return (
    <div style={{ overflowX: 'auto' }}>
      <table className="data-table" style={{ width: '100%' }}>
        <thead>
          <tr>
            <th>Assignee</th>
            <th>Assigned by</th>
            <th>Assigned</th>
            <th>Unassigned</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((a) => (
            <tr key={a.assignmentID || a.assignmentId}>
              <td>{a.userName || userName(a.userID || a.userId)}</td>
              <td>{a.assignedByName || userName(a.assignedBy)}</td>
              <td>{formatDate(a.assignedDttm)}</td>
              <td>{a.isCurrentFlag ? '—' : formatDate(a.unassignedDttm)}</td>
              <td>
                {a.isCurrentFlag ? (
                  <span className="badge badge-success">Current</span>
                ) : (
                  <span className="badge">Ended</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

TicketAssignmentHistory.propTypes = {
  assignments: PropTypes.arrayOf(PropTypes.object),
  userName: PropTypes.func.isRequired,
};
